var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 12H26.5V36H37.5C39.1569 36 40.5 34.6569 40.5 33V15C40.5 13.3431 39.1569 12 37.5 12ZM26.5 10H24.5H11.5C8.73858 10 6.5 12.2386 6.5 15V33C6.5 35.7614 8.73858 38 11.5 38H24.5H26.5H37.5C40.2614 38 42.5 35.7614 42.5 33V15C42.5 12.2386 40.2614 10 37.5 10H26.5ZM11.5 36H24.5V12H11.5C9.84315 12 8.5 13.3431 8.5 15V33C8.5 34.6569 9.84315 36 11.5 36ZM30.5 16.9998C29.9477 16.9998 29.5 17.4476 29.5 17.9998C29.5 18.5521 29.9477 18.9998 30.5 18.9998H36.5C37.0523 18.9998 37.5 18.5521 37.5 17.9998C37.5 17.4476 37.0523 16.9998 36.5 16.9998H30.5ZM29.5 23.0003C29.5 22.448 29.9477 22.0003 30.5 22.0003H36.5C37.0523 22.0003 37.5 22.448 37.5 23.0003C37.5 23.5525 37.0523 24.0003 36.5 24.0003H30.5C29.9477 24.0003 29.5 23.5525 29.5 23.0003ZM30.5 26.9997C29.9477 26.9997 29.5 27.4475 29.5 27.9997C29.5 28.552 29.9477 28.9997 30.5 28.9997H36.5C37.0523 28.9997 37.5 28.552 37.5 27.9997C37.5 27.4475 37.0523 26.9997 36.5 26.9997H30.5Z",
    fill: "#6092DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.8c5d9049.svg";
export { ForwardRef as ReactComponent };